import { Page } from "@/components/wizard";

const PILLARS = [
  { title: "Valutazione clinica e farmacologia", desc: "Rigore medico-scientifico nella diagnosi e nel trattamento della sintomatologia." },
  { title: "Percorso psicoterapeutico", desc: "Uno spazio d'ascolto per comprendere i vissuti ed elaborare il disagio psichico." },
  { title: "Singolarità della persona", desc: "Attenzione al funzionamento individuale e rispetto della neurodiversità." },
];

export default function Profile() {
  return (
    <Page narrow>
      <div data-testid="profile-page">
        <div className="flex items-start gap-4 sm:gap-6">
          <img
            src="/assets/dr-pipitone-portrait.jpg"
            alt="Ritratto del Dr. med. Nicolò Pipitone"
            data-testid="profile-photo"
            className="w-24 h-24 sm:w-32 sm:h-32 rounded-2xl object-cover border border-[#E5E7EB] shrink-0"
          />
          <div className="min-w-0">
            <h1 className="font-display text-3xl sm:text-4xl font-semibold text-[#142D43] tracking-tight leading-tight">
              Dr. med. Nicolò Pipitone
            </h1>
            <p className="mt-2 text-base font-semibold text-[#142D43]">Psichiatra e Psicoterapeuta FMH</p>
            <p className="mt-1 text-base text-[#374151]">Psicoterapeuta a orientamento analitico e dinamico</p>
          </div>
        </div>

        <section className="mt-10" data-testid="profile-approccio">
          <h2 className="font-display text-2xl sm:text-3xl font-semibold text-[#142D43] tracking-tight">L'approccio</h2>
          <div className="mt-4 space-y-4 text-base sm:text-[17px] text-[#374151] leading-[1.7] max-w-[680px]">
            <p className="font-display italic text-lg sm:text-xl text-[#142D43] leading-relaxed">
              "Accanto alla valutazione diagnostica e al trattamento dei sintomi, la psicoterapia può diventare
              uno spazio per comprendere il significato che essi assumono nella storia e nell'esperienza individuale."
            </p>
            <p>
              Il lavoro analitico non si rivolge soltanto al sintomo, ma alla persona nella sua interezza e alla
              comprensione dei processi, anche inconsci, che ne attraversano la vita psichica, con particolare
              riferimento alla psicoterapia psicodinamica e alla Psicologia Analitica di C. G. Jung.
            </p>
          </div>
          <ul className="mt-6 space-y-3" data-testid="profile-pillars">
            {PILLARS.map((p) => (
              <li key={p.title} className="pl-4 border-l-2 border-[#142D43]">
                <p className="text-base font-semibold text-[#142D43]">{p.title}</p>
                <p className="mt-0.5 text-base text-[#374151] leading-relaxed">{p.desc}</p>
              </li>
            ))}
          </ul>
        </section>

        <section className="mt-10" data-testid="profile-bio">
          <h2 className="font-display text-2xl sm:text-3xl font-semibold text-[#142D43] tracking-tight">Formazione ed esperienza</h2>
          <div className="mt-4 space-y-4 text-base sm:text-[17px] text-[#374151] leading-[1.7] max-w-[680px]">
            <p>
              Laureato in Medicina e Chirurgia in Italia (Università Campus Bio-Medico di Roma e Università degli
              Studi di Palermo), ho proseguito la mia formazione in Svizzera presso l'Organizzazione
              Socio-Psichiatrica Cantonale (OSC), dove ho conseguito il titolo di specialista FMH in Psichiatria e
              Psicoterapia.
            </p>
            <p>
              Ho maturato esperienza professionale presso la Clinica Psichiatrica Cantonale di Mendrisio, dove ho
              anche ricoperto il ruolo di medico sostituto Capoclinica nel reparto dedicato agli esordi psicotici, e
              nei servizi territoriali dell'OSC, in particolare nell'Home Treatment – servizio di ricovero
              domiciliare di psichiatria acuta – e nel PATH-Team (Psichiatria Assertiva Territoriale e Housing),
              équipe specializzata nella presa a carico intensiva di persone affette da disturbi psicotici e
              affettivi. Ho inoltre completato un anno di formazione in Neurologia presso la Clinica Hildebrand di
              Brissago, approfondendo le interconnessioni tra disturbi neurologici e psichiatrici.
            </p>
            <p>
              I miei ambiti di interesse comprendono i disturbi d'ansia (attacchi di panico, fobie, ansia
              generalizzata), i disturbi ossessivo-compulsivi, i disturbi depressivi, i disturbi psicosomatici e
              somatoformi, il disturbo da deficit di attenzione/iperattività (ADHD) e i disturbi dello spettro
              autistico dell'adulto.
            </p>
          </div>
        </section>

        <section className="mt-10" data-testid="profile-titles">
          <h2 className="font-display text-2xl sm:text-3xl font-semibold text-[#142D43] tracking-tight">Titoli</h2>
          <div className="mt-4 space-y-3 max-w-[680px]">
            {[
              ["Medico Psichiatra FMH", "Foederatio Medicorum Helveticorum, Svizzera"],
              ["Psicoterapeuta a orientamento junghiano", "Laboratorio di Formazione Analitica della Svizzera Italiana, antenna del C. G. Jung-Institut Zürich"],
              ["TFP Didactic Training Graduate", "Transference Focused Psychotherapy (Otto Kernberg)"],
              ["Psicologo analista in formazione CIPA", "Centro Italiano di Psicologia Analitica"],
              ["Docente SUPSI", "Scuola Universitaria Professionale della Svizzera Italiana"],
            ].map(([title, sub]) => (
              <div key={title}>
                <p className="text-base font-semibold text-[#142D43]">{title}</p>
                <p className="text-sm text-[#374151]">{sub}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </Page>
  );
}
